// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"411":"c2e02cbcae6293ac","426":"6fde7e6b96a9d53d"}[chunkId] + ".css";
};